import { ErrorPageMessagePayload } from '@core/services/server-error';
import { renderPublicPageLayout } from '../public-pages.layout';

class ErrorPageView {
    render(mensagem: ErrorPageMessagePayload): string {
        const conteudo = this.normalizarConteudo(mensagem);

        const mensagemComplementar = conteudo.mensagemComplementar
            ? `<p style="
                color: #5B6475;
                font-size: 16px;
                line-height: 1.6;
                margin: 0 auto 28px;"
            >${this.escapeHtml(conteudo.mensagemComplementar)}</p>`
            : '';
        return renderPublicPageLayout(`
            <div style="
                max-width: 720px;
                margin: 48px auto 0;
                background-color: #FFFFFF;
                border: 1px solid #D9E6F2;
                border-radius: 24px;
                box-shadow: 0 16px 40px rgba(15,78,113,0.08);
                padding: 40px 24px 36px;
                text-align: center;"
            >
                <h1 style="
                    margin: 0 auto 16px;
                    font-size: 28px;
                    line-height: 1.3;
                    color: #0F172A;
                    font-weight: 700;"
                >${this.escapeHtml(conteudo.mensagemPrincipal)}</h1>
                ${mensagemComplementar}
                <a
                    href="${this.escapeHtml(conteudo.url)}"
                    style="
                    display: inline-block;
                    padding: 6px 20px;
                    border-radius: 2rem;
                    border: 1px solid #E5E5E5;
                    background-color: #00469B;
                    color: #FFFFFF;
                    font-size: 14px;
                    font-weight: 700;
                    cursor: pointer;
                    text-decoration: none;"
                >Voltar</a>
            </div>
        `);
    }

    private normalizarConteudo(mensagem: ErrorPageMessagePayload): ErrorPageMessagePayload {
        return {
            mensagemPrincipal: mensagem.mensagemPrincipal || 'Oops! Parece que encontramos um problema por aqui...',
            mensagemComplementar: mensagem.mensagemComplementar,
            url: mensagem.url || ''
        };
    }

    private escapeHtml(valor: string = ''): string {
        return valor
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}

export const ErrorPage = new ErrorPageView();
